/* tslint:disable */
/* eslint-disable */
import { PortalAiChatRole as AceXFoundPortalCoreModelsPortalAiChatRole } from '../../../../../../ace/xFound/Portal/Core/Models/portal-ai-chat-role';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IOpenAiChatRequestDisplayModel {
  content?: null | string;
  isTyping?: boolean;
  role?: AceXFoundPortalCoreModelsPortalAiChatRole;
}
export class OpenAiChatRequestDisplayModel extends BaseModel implements IOpenAiChatRequestDisplayModel {
  content?: null | string;
  isTyping?: boolean;
  role?: AceXFoundPortalCoreModelsPortalAiChatRole;
}
class BaseOpenAiChatRequestDisplayModelFormGroup extends FormGroup {
  private static _instance: OpenAiChatRequestDisplayModelFormGroup;
  
  public static get Instance(): OpenAiChatRequestDisplayModelFormGroup {
    this._instance = new OpenAiChatRequestDisplayModelFormGroup({
      content: new FormControl(null),
      isTyping: new FormControl(null),
      role: new FormControl(null),
    });

    return this._instance;
  }
}


export class OpenAiChatRequestDisplayModelFormGroup extends BaseOpenAiChatRequestDisplayModelFormGroup {
  public get Content(): FormControl {
    return this.controls["content"] as FormControl;
  }
  public get IsTyping(): FormControl {
    return this.controls["isTyping"] as FormControl;
  }
  public get Role(): FormControl {
    return this.controls["role"] as FormControl;
  }
  

}

export module OpenAiChatRequestDisplayModelForm
  {
    export class FormFields
    {
      static _content: string = "content";
      static _isTyping: string = "isTyping";
      static _role: string = "role";
    }
  }

